export enum MobileModalDataHooks {
  CLOSE_BUTTON = 'mobile-modal-close-button',
}
